
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.132 21.162c-.26 0-.52-.1-.71-.29l-5.35-5.325a.989.989 0 010-1.404.999.999 0 011.41 0l4.56 4.54L20.6 7.9a.993.993 0 011.4-.16c.43.339.51.966.16 1.394L12.9 20.793c-.18.22-.44.359-.73.379 0-.01-.02-.01-.04-.01z"}})])
          )
        }
      }
    